/* Sofiya Mart — product page: variant selection, color → image switching, gallery, sticky bar. */
(function () {
  'use strict';
  var SM = window.SM || {};
  var T = SM.strings || {};

  function norm(s) { return String(s == null ? '' : s).trim().toLowerCase(); }

  function ProductPage(root) {
    this.root = root;
    var json = root.querySelector('[data-sm-product-json]');
    if (!json) return;
    this.product = JSON.parse(json.textContent);
    var inv = root.querySelector('[data-sm-inventory-json]');
    try { this.inventory = inv ? JSON.parse(inv.textContent) : {}; } catch (e) { this.inventory = {}; }
    this.colorIndex = parseInt(root.getAttribute('data-color-index'), 10);
    if (isNaN(this.colorIndex)) this.colorIndex = -1;
    this.groupMedia = root.getAttribute('data-group-media') === 'true';
    this.updateUrl = root.getAttribute('data-update-url') === 'true';

    this.form = root.querySelector('[data-sm-product-form]');
    this.idInput = root.querySelector('[data-sm-variant-id]');
    this.track = root.querySelector('[data-sm-track]');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-sm-media-slide]'));
    this.thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-sm-media-thumb]'));
    this.fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-sm-option]'));

    var currentId = this.idInput ? Number(this.idInput.value) : null;
    this.variant = this.product.variants.filter(function (v) { return v.id === currentId; })[0] || this.product.variants[0];

    this.buildMediaGroups();
    this.bindOptions();
    this.bindGallery();
    this.bindQty();
    this.bindForm();
    this.bindSticky();
    this.updateAvailability();
    if (this.groupMedia) this.applyMediaGroup();
    var fm = this.variant && this.variant.featured_media;
    if (fm) this.showMedia(fm.id, false);
    else this.syncThumbs();
  }

  /* ---------- Options ---------- */
  ProductPage.prototype.selectedOptions = function () {
    return this.fieldsets.map(function (fs) {
      var sel = fs.querySelector('[data-sm-option-select]');
      if (sel) return sel.value;
      var checked = fs.querySelector('input[data-sm-option-input]:checked');
      return checked ? checked.value : null;
    });
  };

  ProductPage.prototype.setOptionValue = function (index, value) {
    var fs = this.fieldsets[index];
    if (!fs) return;
    var sel = fs.querySelector('[data-sm-option-select]');
    if (sel) { sel.value = value; return; }
    fs.querySelectorAll('input[data-sm-option-input]').forEach(function (inp) { inp.checked = inp.value === value; });
  };

  ProductPage.prototype.bindOptions = function () {
    var self = this;
    this.fieldsets.forEach(function (fs) {
      fs.addEventListener('change', function () { self.onOptionChange(Number(fs.getAttribute('data-index'))); });
    });
  };

  ProductPage.prototype.findVariant = function (opts) {
    return this.product.variants.filter(function (v) {
      return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; });
    })[0];
  };

  ProductPage.prototype.onOptionChange = function (changedIndex) {
    var opts = this.selectedOptions();
    var variant = this.findVariant(opts);
    if (!variant) {
      // Keep the value the shopper just picked; choose the best matching variant for the rest.
      var picked = opts[changedIndex];
      var candidates = this.product.variants.filter(function (v) { return v.options[changedIndex] === picked; });
      var score = function (v) {
        var s = v.available ? 100 : 0;
        v.options.forEach(function (o, i) { if (o === opts[i]) s += 10 - i; });
        return s;
      };
      candidates.sort(function (a, b) { return score(b) - score(a); });
      variant = candidates[0];
      if (variant) {
        var self = this;
        variant.options.forEach(function (o, i) { self.setOptionValue(i, o); });
      }
    }
    this.setVariant(variant, changedIndex === this.colorIndex || this.colorIndex === -1);
  };

  ProductPage.prototype.updateAvailability = function () {
    var self = this;
    var opts = this.selectedOptions();
    this.fieldsets.forEach(function (fs, i) {
      var current = fs.querySelector('[data-sm-option-current]');
      if (current) current.textContent = opts[i] || '';
      var inputs = fs.querySelectorAll('input[data-sm-option-input]');
      inputs.forEach(function (inp) {
        var test = opts.slice();
        test[i] = inp.value;
        var matches = self.product.variants.filter(function (v) {
          return v.options.every(function (o, j) {
            // For availability, only constrain by options chosen before this one (Shopify convention)
            return j > i ? true : o === test[j];
          });
        });
        var exact = self.findVariant(test);
        var available = exact ? exact.available : matches.some(function (v) { return v.available; });
        var label = inp.nextElementSibling;
        if (!label) return;
        label.classList.toggle('is-soldout', !available);
        label.classList.toggle('is-missing', matches.length === 0);
      });
    });
  };

  ProductPage.prototype.setVariant = function (variant, moveMedia) {
    if (!variant) {
      this.setButtons(false, true);
      return;
    }
    this.variant = variant;
    if (this.idInput) {
      this.idInput.value = variant.id;
      this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    this.root.querySelectorAll('form[id^="SmInstallments"] input[name="id"]').forEach(function (i) {
      i.value = variant.id;
      i.dispatchEvent(new Event('change', { bubbles: true }));
    });
    this.updateAvailability();
    this.updatePrice();
    this.setButtons(variant.available, false);
    this.updateSku();
    this.updateStock();
    if (this.groupMedia) this.applyMediaGroup();
    if (variant.featured_media) this.showMedia(variant.featured_media.id, true);
    else if (this.groupMedia && this.visibleSlides()[0]) this.showMedia(this.visibleSlides()[0].getAttribute('data-media-id'), true);
    this.updateSticky();
    if (this.updateUrl && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    document.dispatchEvent(new CustomEvent('sm:variant-change', { detail: { variant: variant, product: this.product } }));
  };

  /* ---------- Price / buttons ---------- */
  ProductPage.prototype.qty = function () {
    var q = this.root.querySelector('[data-sm-qty-input]');
    return Math.max(1, parseInt(q && q.value, 10) || 1);
  };

  ProductPage.prototype.updatePrice = function () {
    var v = this.variant;
    var wrap = this.root.querySelector('[data-sm-product-price]');
    if (!wrap || !v) return;
    var cur = wrap.querySelector('[data-sm-price-current]');
    var cmp = wrap.querySelector('[data-sm-price-compare]');
    var badge = wrap.querySelector('[data-sm-price-badge]');
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    if (cur) cur.textContent = SM.formatMoney(v.price);
    if (cmp) { cmp.hidden = !onSale; cmp.textContent = onSale ? SM.formatMoney(v.compare_at_price) : ''; }
    if (badge) {
      badge.hidden = !onSale;
      badge.textContent = onSale ? (T.saveAmount || 'Save [amount]').replace('[amount]', SM.formatMoney(v.compare_at_price - v.price)) : '';
    }
  };

  ProductPage.prototype.setButtons = function (available, unavailable) {
    var btn = this.root.querySelector('[data-sm-add-button]');
    var buyNow = this.root.querySelector('[data-sm-buy-now]');
    var dyn = this.root.querySelector('[data-sm-dynamic]');
    var sticky = this.root.querySelector('[data-sm-sticky-add]');
    var label;
    if (unavailable) label = T.unavailable || 'Unavailable';
    else if (!available) label = T.soldOut || 'Sold out';
    else if (btn && btn.getAttribute('data-show-total') === 'true') label = (T.addToCartTotal || '[price]').replace('[price]', SM.formatMoney(this.variant.price * this.qty()));
    else label = T.addToCart || 'Add to cart';
    if (btn) { btn.disabled = !available || unavailable; btn.textContent = label; }
    if (buyNow) buyNow.hidden = !available || unavailable;
    if (dyn) dyn.hidden = !available || unavailable;
    if (sticky) {
      sticky.disabled = !available || unavailable;
      sticky.textContent = available && !unavailable ? (T.addToCart || 'Add to cart') : label;
    }
  };

  ProductPage.prototype.updateSku = function () {
    var el = this.root.querySelector('[data-sm-sku]');
    if (!el) return;
    var sku = this.variant && this.variant.sku;
    el.hidden = !sku;
    if (sku) el.textContent = el.textContent.replace(/:\s*.*$/, ': ' + sku);
  };

  ProductPage.prototype.updateStock = function () {
    var el = this.root.querySelector('[data-sm-stock]');
    if (!el || !this.variant) return;
    var info = this.inventory[String(this.variant.id)] || {};
    var low = parseInt(el.getAttribute('data-low'), 10) || 5;
    var dot = '<span class="sm-pdp__stock-dot{cls}"></span>';
    var s = SM.stockStrings || {};
    if (!this.variant.available) {
      el.innerHTML = dot.replace('{cls}', ' is-out') + (s.out || '');
    } else if (info.m === 'shopify' && info.q > 0 && info.q <= low) {
      el.innerHTML = dot.replace('{cls}', ' is-low') + (s.low || '').replace('[count]', info.q);
    } else {
      el.innerHTML = dot.replace('{cls}', '') + (s.in || '');
    }
  };

  /* ---------- Media ---------- */
  ProductPage.prototype.buildMediaGroups = function () {
    var self = this;
    this.groups = null;
    if (this.colorIndex < 0 || !this.slides.length) return;
    var colorOpt = this.product.options[this.colorIndex];
    var values = (this.product.options_with_values && this.product.options_with_values[this.colorIndex])
      ? this.product.options_with_values[this.colorIndex].values
      : null;
    if (!values) {
      values = [];
      this.product.variants.forEach(function (v) { if (values.indexOf(v.options[self.colorIndex]) < 0) values.push(v.options[self.colorIndex]); });
    }
    values = values.map(function (v) { return typeof v === 'string' ? v : (v && v.name) || String(v); });
    void colorOpt;
    var groups = {};
    var ids = this.slides.map(function (s) { return s.getAttribute('data-media-id'); });

    // 1) alt-text grouping
    var altMatched = false;
    var shared = [];
    this.slides.forEach(function (s) {
      var alt = norm(s.getAttribute('data-alt'));
      var hit = null;
      values.forEach(function (val) { if (alt && (alt === norm(val) || alt.indexOf(norm(val)) > -1)) hit = val; });
      if (hit) { altMatched = true; (groups[hit] = groups[hit] || []).push(s.getAttribute('data-media-id')); }
      else shared.push(s.getAttribute('data-media-id'));
    });
    if (!altMatched) {
      // 2) sequence grouping: each color's variant image starts its group
      groups = {};
      var starts = [];
      values.forEach(function (val) {
        var v = self.product.variants.filter(function (x) { return x.options[self.colorIndex] === val && x.featured_media; })[0];
        if (v) {
          var idx = ids.indexOf(String(v.featured_media.id));
          if (idx > -1) starts.push({ val: val, idx: idx });
        }
      });
      if (!starts.length) return;
      starts.sort(function (a, b) { return a.idx - b.idx; });
      shared = ids.slice(0, starts[0].idx);
      starts.forEach(function (st, n) {
        var end = n + 1 < starts.length ? starts[n + 1].idx : ids.length;
        // a later color pointing at the same image shares it
        if (end <= st.idx) end = st.idx + 1;
        groups[st.val] = (groups[st.val] || []).concat(ids.slice(st.idx, end));
      });
    }
    this.groups = { byColor: groups, shared: shared };
  };

  ProductPage.prototype.applyMediaGroup = function () {
    if (!this.groups || !this.variant) return;
    var color = this.variant.options[this.colorIndex];
    var list = this.groups.byColor[color];
    var show = list && list.length ? list.concat(this.groups.shared) : null;
    var toggle = function (el) {
      var id = el.getAttribute('data-media-id');
      el.classList.toggle('is-hidden', !!show && show.indexOf(id) < 0);
    };
    this.slides.forEach(toggle);
    this.thumbs.forEach(toggle);
  };

  ProductPage.prototype.visibleSlides = function () {
    return this.slides.filter(function (s) { return !s.classList.contains('is-hidden'); });
  };

  ProductPage.prototype.showMedia = function (mediaId, smooth) {
    mediaId = String(mediaId);
    var slide = this.slides.filter(function (s) { return s.getAttribute('data-media-id') === mediaId; })[0];
    if (!slide || !this.track) return;
    if (slide.classList.contains('is-hidden')) slide = this.visibleSlides()[0] || slide;
    this.activeId = slide.getAttribute('data-media-id');
    var left = slide.offsetLeft - this.track.offsetLeft;
    var prevBehavior = this.track.style.scrollBehavior;
    if (!smooth) this.track.style.scrollBehavior = 'auto';
    this.track.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
    if (!smooth) {
      var tr = this.track;
      requestAnimationFrame(function () { tr.style.scrollBehavior = prevBehavior; });
    }
    this.slides.forEach(function (s) {
      s.classList.toggle('is-active', s === slide);
      var v = s.querySelector('video');
      if (v && s !== slide) v.pause();
    });
    this.syncThumbs();
  };

  ProductPage.prototype.syncThumbs = function () {
    var id = this.activeId || (this.slides[0] && this.slides[0].getAttribute('data-media-id'));
    var activeThumb = null;
    this.thumbs.forEach(function (t) {
      var on = t.getAttribute('data-media-id') === id;
      t.setAttribute('aria-current', on ? 'true' : 'false');
      if (on) activeThumb = t;
    });
    if (activeThumb && activeThumb.parentElement && activeThumb.parentElement.scrollWidth > activeThumb.parentElement.clientWidth) {
      var p = activeThumb.parentElement;
      p.scrollTo({ left: activeThumb.offsetLeft - p.clientWidth / 2 + activeThumb.clientWidth / 2, behavior: 'smooth' });
    }
  };

  ProductPage.prototype.bindGallery = function () {
    var self = this;
    this.thumbs.forEach(function (t) {
      t.addEventListener('click', function () { self.showMedia(t.getAttribute('data-media-id'), true); });
    });
    var step = function (dir) {
      var vis = self.visibleSlides();
      var i = vis.findIndex(function (s) { return s.getAttribute('data-media-id') === self.activeId; });
      var n = vis[(Math.max(0, i) + dir + vis.length) % vis.length];
      if (n) self.showMedia(n.getAttribute('data-media-id'), true);
    };
    var prev = this.root.querySelector('[data-sm-media-prev]');
    var next = this.root.querySelector('[data-sm-media-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    if (this.track) {
      this.track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      });
      var onScroll = SM.debounce ? SM.debounce(function () {
        var w = self.track.clientWidth;
        var vis = self.visibleSlides();
        var best = null, bestDist = Infinity;
        vis.forEach(function (s) {
          var d = Math.abs((s.offsetLeft - self.track.offsetLeft) - self.track.scrollLeft);
          if (d < bestDist) { bestDist = d; best = s; }
        });
        if (best && w) {
          var id = best.getAttribute('data-media-id');
          if (id !== self.activeId) {
            self.activeId = id;
            self.slides.forEach(function (s) { s.classList.toggle('is-active', s === best); });
            self.syncThumbs();
          }
        }
      }, 80) : null;
      if (onScroll) this.track.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { if (self.activeId) self.showMedia(self.activeId, false); });
    }
  };

  /* ---------- Quantity ---------- */
  ProductPage.prototype.bindQty = function () {
    var self = this;
    var wrap = this.root.querySelector('[data-sm-qty]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-sm-qty-input]');
    var update = function (d) {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + d);
      self.setButtons(self.variant && self.variant.available, !self.variant);
    };
    wrap.querySelector('[data-sm-qty-minus]').addEventListener('click', function () { update(-1); });
    wrap.querySelector('[data-sm-qty-plus]').addEventListener('click', function () { update(1); });
    input.addEventListener('change', function () { update(0); });
  };

  /* ---------- Add to cart ---------- */
  ProductPage.prototype.bindForm = function () {
    var self = this;
    if (!this.form) return;
    var err = this.root.querySelector('[data-sm-form-error]');
    var submit = function (goCheckout, trigger) {
      if (!self.variant || !self.variant.available) return;
      if (err) err.hidden = true;
      var fd = new FormData(self.form);
      var item = { id: self.variant.id, quantity: self.qty() };
      var props = {};
      fd.forEach(function (val, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m && val !== '') props[m[1]] = val;
      });
      if (Object.keys(props).length) item.properties = props;
      var sp = fd.get('selling_plan');
      if (sp) item.selling_plan = sp;
      if (goCheckout) {
        trigger.classList.add('is-loading');
        fetch((SM.settings && SM.settings.cartAddUrl) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        }).then(function (r) { return r.json(); }).then(function (d) {
          if (d.status) throw new Error(d.description || d.message);
          window.location.href = (SM.settings && SM.settings.checkoutUrl) || '/checkout';
        }).catch(function (e) {
          trigger.classList.remove('is-loading');
          if (err) { err.textContent = e.message || T.error; err.hidden = false; }
        });
        return;
      }
      SM.cart.add([item], trigger).catch(function (e) {
        if (err) { err.textContent = e.message || T.error; err.hidden = false; }
      });
    };
    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      submit(false, self.root.querySelector('[data-sm-add-button]'));
    });
    var buyNow = this.root.querySelector('[data-sm-buy-now]');
    if (buyNow) buyNow.addEventListener('click', function () { submit(true, buyNow); });
    this.submit = submit;
  };

  /* ---------- Sticky bar ---------- */
  ProductPage.prototype.bindSticky = function () {
    var self = this;
    var bar = this.root.querySelector('[data-sm-sticky-atc]');
    var btn = this.root.querySelector('[data-sm-add-button]');
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    this.sticky = bar;
    var footer = document.querySelector('.sm-footer');
    var mainVisible = true, footerVisible = false;
    var render = function () {
      var show = !mainVisible && !footerVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var add = bar.querySelector('[data-sm-sticky-add]');
      if (add) add.tabIndex = show ? 0 : -1;
      document.body.style.paddingBottom = show ? bar.offsetHeight + 'px' : '';
    };
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { mainVisible = en.isIntersecting || en.boundingClientRect.top > 0; });
      render();
    }).observe(btn);
    if (footer) new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { footerVisible = en.isIntersecting; });
      render();
    }).observe(footer);
    var add = bar.querySelector('[data-sm-sticky-add]');
    if (add) add.addEventListener('click', function () { if (self.submit) self.submit(false, add); });
  };

  ProductPage.prototype.updateSticky = function () {
    var bar = this.sticky;
    if (!bar || !this.variant) return;
    var label = bar.querySelector('[data-sm-sticky-label]');
    var price = bar.querySelector('[data-sm-sticky-price]');
    var img = bar.querySelector('.sm-sticky-atc__thumb img');
    if (label) label.textContent = this.variant.title === 'Default Title' ? '' : this.variant.title;
    if (price) price.textContent = SM.formatMoney(this.variant.price);
    if (img && this.variant.featured_media && this.variant.featured_media.preview_image) {
      var src = this.variant.featured_media.preview_image.src;
      img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      img.removeAttribute('srcset');
    }
  };

  /* ---------- Boot ---------- */
  function init(scope) {
    (scope || document).querySelectorAll('[data-sm-product]').forEach(function (el) {
      if (el.__smProduct) return;
      el.__smProduct = new ProductPage(el);
    });
  }
  SM.ProductPage = ProductPage;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
